module.exports = __webpack_public_path__ + "img/no-live.39244432.png";